import { Component } from '@angular/core';

import { StaticToastService } from './toast-static.service';

@Component({
  selector: 'sondermind-static-toast',
  template: `
        <sondermind-toast
            *ngIf="notification$ | async as notification"
            [severity]="notification.severity"
            [message]="notification.message"
            (dismissed)="clearNotification()"
            [autoHide]="false">
        </sondermind-toast>
    `,
  standalone: false
})
export class StaticToastComponent {
  constructor(
    private staticToast: StaticToastService
  ) {}

  notification$ = this.staticToast.notification$;

  clearNotification() {
    this.staticToast.clearNotification();
  }
}
